import ChatPanel from "@/components/chat/ChatPanel";

export default function CoachMessages() {
  return (
    <div data-testid="coach-messages-page" className="w-full max-w-full min-w-0 h-full flex flex-col overflow-hidden">
      <h1 className="font-heading text-3xl font-bold tracking-tight uppercase text-slate-900 mb-4 shrink-0">Messages</h1>
      <div className="flex-1 min-h-0">
        <ChatPanel mode="coach" />
      </div>
    </div>
  );
}